import {CoreObjectId, DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';

export default function isProcedureVersionPoW(version: string): boolean {
  return getObjectType({id: version as CoreObjectId}) === DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION;
}
